import React from 'react';
import { useLocation } from 'react-router-dom';
import { Text, TextVariant } from '@naf/text';
import { VippsLoginButton } from '@components/VippsLoginButton';
import { InternalSearchCardType } from '@components/layout/InternalSearchMetaData';
import { Layout } from '@components/layout/Layout';
import Logo from '@assets/images/logo.png';
import { MAIN_DESCRIPTION, MAIN_TITLE, MEMBERPAGES_URL } from '@lib/constants';
import { loginPath } from '@universal/apps/Themed/ThemedApp.utils';
import * as S from './Login.styles';
import { useLoginFunctions } from './useLoginFunctions';

export const Login = () => {
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const returnUrl = params.get('returnUrl') || `/${MEMBERPAGES_URL}`;

  const { handleSmsLogin, handleEmailLogin, handleRegister, redirectToHomePage } = useLoginFunctions();

  return (
    <Layout
      title={MAIN_TITLE}
      description={MAIN_DESCRIPTION}
      url={loginPath}
      internalSearchMetaData={{ cardType: InternalSearchCardType.Simple }}
    >
      <S.PageWrapper>
        <S.LoginBox>
          <S.Header>
            <S.Logo src={Logo} alt="NAF Logo" onClick={redirectToHomePage} />
            <Text variant={TextVariant.Header2}>Velkommen</Text>
            <Text variant={TextVariant.BodyTextSubHeader}>Logg inn for å fortsette</Text>
          </S.Header>

          <S.ButtonWrapper>
            <VippsLoginButton returnUrl={returnUrl} verb="login" isStretched />
            <S.LoginButton onClick={() => handleSmsLogin(returnUrl)} target="_self" variant="outlined" width="full">
              <S.PhoneIcon size="24" />
              Logg inn med SMS
            </S.LoginButton>
            <S.LoginButton onClick={() => handleEmailLogin(returnUrl)} target="_self" variant="outlined" width="full">
              <S.DraftsIcon size="24" />
              Logg inn med epost
            </S.LoginButton>
          </S.ButtonWrapper>

          <Text tag="p" variant={TextVariant.ArticleText}>
            <S.FooterText>Har du ikke konto? </S.FooterText>
            <S.RegisterLink onClick={handleRegister}>Registrer deg her</S.RegisterLink>
          </Text>
        </S.LoginBox>
      </S.PageWrapper>
    </Layout>
  );
};

export default Login;
